import React from 'react'
import styled from 'styled-components'
import { Box, Text } from 'pcln-design-system'
import { Overnight } from 'pcln-icons'
import PropTypes from 'prop-types'

const InlineFlex = styled(Text)`
  display: inline-flex;
`

const DisplayDate = styled(Box)`
  ${(props) => props.theme.mediaQueries.md} {
    display: inline-flex;
  }
`

const FloatRight = styled(Text)`
  ${(props) => props.theme.mediaQueries.md} {
    float: right;
    display: inline-flex;
  }
`

const ExpressDealSlices = ({ slices, isPkg, ...props }) => (
  <Box {...props} data-testid='express-deal-slices-container'>
    {slices.map((slice, i) => (
      <Box key={`slice${i}`} data-testid={`express-deal-slice${!!slice.displayDate && '-alt-date'}`}>
        <Box m={3}>
          {slice.displayDate && (
            <DisplayDate>
              <Text.span bold fontSize={[0, 1]} mr={3} bg={slice.isAltDate ? 'alert.light' : null}>
                {slice.displayDate}
              </Text.span>
            </DisplayDate>
          )}
          <InlineFlex fontSize={[0, 1]} data-testid='express-deal-slice-time-window'>
            <Text.span bold mr={3}>
              <Text.span data-testid={`slice-${i}-departure`} bg={slice.altOriginAirport && 'alert.light'}>
                {slice.departure}
              </Text.span>
              <Text.span mx={1}>-</Text.span>
              <Text.span data-testid={`slice-${i}-arrival`} bg={slice.altDestinationAirport && 'alert.light'}>
                {slice.arrival}
              </Text.span>
            </Text.span>
            <Text.span bold>{slice.takeoff}</Text.span>
            <Text.span ml={1}>takeoff</Text.span>
            {slice.isOvernight && <Overnight title='Overnight Flight' mt='-2px' ml={2} size='18px' />}
          </InlineFlex>
          {isPkg && typeof slice.maximumStops === 'number' && (
            <FloatRight ml='auto' fontSize={[0, 1]}>
              {slice.maximumStops === 0
                ? 'Nonstop'
                : `${slice.maximumStops} Stop${slice.maximumStops > 1 ? 's' : ''}`}
            </FloatRight>
          )}
        </Box>
        {slices.length > 1 && i === 0 && <Box color='border.base' width={1} height='1px' mr={3} />}
      </Box>
    ))}
  </Box>
)

ExpressDealSlices.propTypes = {
  isPkg: PropTypes.bool,
  slices: PropTypes.arrayOf(
    PropTypes.shape({
      departure: PropTypes.string,
      arrival: PropTypes.string,
      takeoff: PropTypes.string,
      maximumStops: PropTypes.number,
      isOvernight: PropTypes.bool,
      displayDate: PropTypes.string,
      altOriginAirport: PropTypes.bool,
      altDestinationAirport: PropTypes.bool,
      isAltDate: PropTypes.bool,
    })
  ),
}

export { ExpressDealSlices }
